import { seoDefaults } from "config/seo"
import { useLocale } from "hooks"
import React from "react"
import { usePageUrl } from "utils/usePageUrl"
import { useHomeUrl } from "utils/useHomeUrl"

type Props = {
  title: string
}

export const LandingPageSeo: React.FC<Props> = ({ title }) => {
  const locale = useLocale()
  const pageUrl = usePageUrl()
  const homeUrl = useHomeUrl()

  const pageSchema = Object.freeze({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": homeUrl,
        url: homeUrl,
        name: seoDefaults.siteName[locale],
        description: seoDefaults.description[locale],
        inLanguage: locale,
      },
      {
        "@type": ["WebPage", "CollectionPage"],
        "@id": pageUrl,
        url: pageUrl,
        name: title,
        isPartOf: {
          "@id": homeUrl,
        },
      },
    ],
  })

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(pageSchema),
      }}
    />
  )
}
